$(document).on("charges#edit:loaded charges#new:loaded charges#create:loaded charges#update:loaded", function() {
  locale = gon.I18n;


  $.datepicker.setDefaults($.datepicker.regional[locale]);  

  $('#prp_transaction_date_posted').datepicker({
  showOn: 'button',
    changeYear: true,
    changeMonth: true,
    yearRange:"-10:+10"});

  $('#prp_transaction_date_posted').next('button.ui-datepicker-trigger').css("verticalAlign","middle");

});


$(document).on("charges#index:loaded", function() {

  $("#charge_search input").keyup(function()
  {
    $.get($("#charge_search").attr("action"), $("#charge_search").serialize(), null, "script");
    return false
  });
});